export enum MassActionsReducerActionsTypeEnum {
  CLEAR_SELECTED_ITEMS = 'CLEAR_SELECTED_ITEMS',
  TOGGLE_ITEM = 'TOGGLE_ITEM',
  TOGGLE_ITEMS = 'TOGGLE_ITEMS',
  SYNC_AND_TOGGLE_ITEMS = 'SYNC_AND_TOGGLE_ITEMS',
  SELECT_ITEM = 'SELECT_ITEM',
  SELECT_ITEMS = 'SELECT_ITEMS',
  CLEAR_AND_SELECT_ITEMS = 'CLEAR_AND_SELECT_ITEMS',
  REMOVE_ITEM = 'REMOVE_ITEM',
  REMOVE_ITEMS = 'REMOVE_ITEMS',
  RESET_STATE = 'RESET_STATE',
  ADD_ALL_IF_NONE_SELECTED_OR_CLEAR_ALL = 'ADD_ALL_IF_NONE_SELECTED_OR_CLEAR_ALL',
}
